// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill'

import Vue from 'vue'

import axios from 'axios'

import router from './router'
import store from './store'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

import Toasted from 'vue-toasted'

// import ConfirmDialog from '@/plugins/confirm'
// import EventBus from '@/plugins/eventBus'

import './styles/main.sass'

import App from './App'

Vue.use(Vuetify)
const vuetify = new Vuetify()

Vue.use(Toasted, {
  duration: 5000
})

// Vue.use(ConfirmDialog, {
//   buttonTrueText: 'Confirm',
//   buttonFalseText: 'Cancel',
//   buttonFalseColor: 'red',
//   color: 'primary darken-1',
//   title: 'Confirmation',
//   width: 350,
//   context: { vuetify }
// })
//
// Vue.use(EventBus)

Vue.config.productionTip = false

const axiosInstance = axios.create({
  baseURL: process.env.API_HOST
})

axiosInstance.interceptors.request.use(function (config) {
  if (store.state.token) {
    config.headers.Authorization = `Bearer ${store.state.token}`
  }

  return config
}, function (error) {
  return Promise.reject(error)
})

axiosInstance.interceptors.response
  .use(response => response, error => {
    if (error.response && error.response.status === 401) {
      store.commit('LOGOUT')
      router.push('/login')
    }
    return Promise.reject(error)
  })
Vue.http = Vue.prototype.$http = axiosInstance

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  vuetify,
})



// WEBPACK FOOTER //
// ./src/main.js